import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Layout, Button } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import Login from './components/Login';
import AdminRegister from './components/AdminRegister';
import Users from './components/Users';
import Orders from './components/Orders';
import Transactions from './components/Transactions';
import DepositApprovals from './components/DepositApprovals';
import WithdrawalApprovals from './components/WithdrawalApprovals';
import Settings from './components/Settings';
import MarginSettings from './components/MarginSettings';
import Stocks from './components/Stocks';
import Analytics from './components/Analytics';
import Sidebar from './components/Sidebar';
import { AuthProvider, useAuth } from './context/AuthContext';
import './App.css';

const { Content, Header } = Layout;

function ProtectedRoute({ children }) {
  const { token } = useAuth();
  return token ? children : <Navigate to="/login" />;
}

function MainLayout() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sidebar mobileMenuOpen={mobileMenuOpen} onMobileMenuToggle={setMobileMenuOpen} />
      
      {/* Mobile Header */}
      <div className="mobile-header">
        <Button
          type="text"
          icon={<MenuOutlined />}
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          style={{
            fontSize: '16px',
            width: 64,
            height: 64,
            color: '#1e3a8a'
          }}
        />
        <h3 style={{ margin: 0, color: '#1e3a8a' }}>Trading Admin</h3>
      </div>
      
      <Layout className={`main-layout ${mobileMenuOpen ? 'sidebar-open' : ''}`}>
        <Content style={{ 
          margin: 0,
          padding: '24px',
          background: '#f8fafc',
          minHeight: '100vh',
          overflow: 'auto'
        }}>
          <Routes>
            <Route path="/" element={<Navigate to="/users" />} />
            <Route path="/users" element={<Users />} />
            <Route path="/orders" element={<Orders />} />
            <Route path="/transactions" element={<Transactions />} />
            <Route path="/deposit-approvals" element={<DepositApprovals />} />
            <Route path="/withdrawal-approvals" element={<WithdrawalApprovals />} />
            <Route path="/margin-settings" element={<MarginSettings />} />
            <Route path="/settings" element={<Settings />} />
            {/*<Route path="/stocks" element={<Stocks />} />
            <Route path="/analytics" element={<Analytics />} />*/}
          </Routes>
        </Content>
      </Layout>
      
      {/* Mobile Overlay */}
      {mobileMenuOpen && (
        <div 
          className="mobile-overlay"
          onClick={() => setMobileMenuOpen(false)}
        />
      )}
    </Layout>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<AdminRegister />} />
            <Route path="/*" element={
              <ProtectedRoute>
                <MainLayout />
              </ProtectedRoute>
            } />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;